import { ConnectionEvents } from '../globals/constant';
export class ConnectionBusyEvent {
    constructor(connectionId, task) {
        this.name = ConnectionEvents.ConnectionBusy;
        this.connectionId = connectionId;
        this.task = task;
    }
    hasTask() {
        return Boolean(this.task);
    }
    getTask() {
        return this.task;
    }
}
